import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  POST_LOGIN_SUCCESS,
  POST_LOGIN_FAIL,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAIL,
  EMP_VERIFY_OTP_FAIL,
  EMP_VERIFY_OTP_SUCCESS,
  EMPLOYEE_LOGIN_SUCCESS,
  EMPLOYEE_LOGIN_FAIL,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_FAIL,
  ADMIN_RESEND_OTP_SUCCESS,
  ADMIN_RESEND_OTP_FAIL,
  SUPER_ADMIN_LOGIN_SUCCESS,
  SUPER_ADMIN_LOGIN_FAIL,
  REPORT_LOGIN_SUCCESS,
  REPORT_LOGIN_FAIL,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  adminData: [],
  response: [],
  otpRes: [],
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_RESEND_OTP_SUCCESS:
      return {
        ...state,
        otpRes: action.payload,
      };
    case ADMIN_RESEND_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUPER_ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        adminData: action.payload,
      };
    case SUPER_ADMIN_LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case RESEND_OTP_SUCCESS:
      return {
        ...state,
        otpRes: action.payload,
      };
    case RESEND_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EMPLOYEE_LOGIN_SUCCESS:
      return {
        ...state,
        response: action.payload,
      };
    case EMPLOYEE_LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EMP_VERIFY_OTP_SUCCESS:
      return {
        ...state,
        response: action.payload,
      };
    case EMP_VERIFY_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        response: action.payload,
      };
    case VERIFY_OTP_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REPORT_LOGIN_SUCCESS:
      return {
        ...state,
        adminData: action.payload,
      };
    case REPORT_LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case POST_LOGIN_SUCCESS:
      return {
        ...state,
        adminData: action.payload,
      };
    case POST_LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOGOUT_USER:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
